import Currencies from '../constants/Currencies';

const currencySymbol = (currencyCode) => {
  if (currencyCode) {
    if (Currencies[currencyCode]) { return Currencies[currencyCode].symbol; }
    return `${currencyCode} `;
  }
  return Currencies.USD.symbol;
};

export default currencySymbol;
